<template>
    <dx-drop-down-box
        width='100%'
        ref='dropBoxRef'
        v-model:value="selectItem"
        v-model:opened="isOpened"
        :value='selectItem'
        :display-expr="item => item?.name"
        :value-expr="item => item?.kod"
        :disabled="isDisabled"
        :openOnFieldClick="false"
        :showDropDownButton="false"
        :showClearButton="false"
        field-template="field"
        contentTemplate="contentTemplate"
        :drop-down-options="dropDownOptions"
    >
        <template #field>
            <dx-text-box
                ref="inputSearchRef"
                :value="textSearch"
                @input="onInput"
                :disabled="isDisabled"
                placeholder='Поиск по дереву...'
                @value-changed="onValueChange"
            ></dx-text-box>
            <div class="clearBtn dx-show-clear-button" v-if="isClearButton" @click="clearAll">
                <span class="dx-icon dx-icon-clear"></span>
            </div>
        </template>
        <template #contentTemplate>
            <div v-show="isContentReady" class='tep-loader-wrap-outer'>
                <div class='tep-loader-wrap-inner'>
                    <div class="absolute top-1/2 left-[45%]"><dx-loader /></div>
                </div>
            </div>
            <div v-if="!isContentReady" style="height: 100%">
                <dx-data-grid
                    ref="gridRef"
                    height="100%"
                    class="h-0 grow"
                    :data-source="dataSource"
                    :key-expr="meta.keyExpr"
                    :columns="meta.columns"
                    :hover-state-enabled="true"
                    :selection_mode="'single'"
                    :paging="false"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :scrolling="'standart'"
                    :word-wrap-enabled="true"
                    @row-click="onSelectValue"
                ></dx-data-grid>
            </div>
        </template>
    </dx-drop-down-box>
</template>
<script>
export default {
    name: 'tep-tree-search',
};
</script>
<script setup>
import { computed, ref } from 'vue';
import { DxDropDownBox, DxTextBox } from 'devextreme-vue';
import tepService from '@/service/tep-service';
import DxLoader from '@/components/loader/dx-loader.vue';
import { DxDataGrid } from 'devextreme-vue/data-grid';
import store from '@/views/tep/tep-grid/store/tep-tree-store';

const dropBoxRef =ref(null);
const inputSearchRef = ref(null);

const isDisabled = ref(false);
const selectItem = ref(null);
const textSearch = ref(null);
const isOpened = ref(false);
const dataSource = ref([]);
const isContentReady = ref(false);

const dropDownOptions = {
    width: 800,
    height: 350,
};

const emits = defineEmits(['openSearchItemTree']);

const isClearButton = computed(() => {
    return Boolean(textSearch.value) || false;
});

const loadData = async () => {
    let searchStr = textSearch.value;
    searchStr = searchStr.trim();
    if (searchStr.length < 3) {
        dataSource.value = [];
        return;
    }
    isOpened.value = true;
    isContentReady.value = true;
    const result = await tepService.getTepTreeSearch(searchStr);
    dataSource.value = result ?? [];
    isContentReady.value = false;
    isDisabled.value = false;
    isClearButton.value = true;
    setTimeout(() => {
        inputSearchRef.value?.instance.focus()
    }, 1000)

}

const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    };
}

const onInput = debounce(async(e) => {
    textSearch.value = e.component.option("text");
    isOpened.value = false;
    dataSource.value = [];
    if(textSearch.value?.length >= 3) {
        isDisabled.value = true;
        await loadData();
   }
},1000);

const onValueChange = debounce(async(e) => {
    isOpened.value = false;
    dataSource.value = [];
    textSearch.value = e.value
    if(textSearch.value?.length >= 3) {
        isDisabled.value = true;
    }
},1000);

const onSelectValue = async (event) => {
    selectItem.value = event.data;
    // textSearch.value = event.data.name;
    isOpened.value = false;
    dataSource.value = [];
    await store.loadTepTreeData(event.data.kod, true);
    emits('openSearchItemTree', event.data, store.state.rootParentId);

}

const clearAll = () => {
    selectItem.value = null;
    textSearch.value = null;
    isOpened.value = false;
    dataSource.value = [];
}

const meta = {
    keyExpr: 'kod',
    wordWrapEnabled: true,
    fieldNameText: "name",
    fieldNameId: "kod",
    api: {
        select: 'tep-grid./tep/tep-tree/search/get'
    },
    columns: [
        {
            caption: 'Код',
            name: 'kod',
            dataField: 'kod',
            visible: true,
            width: 100,
            index: 1,
            allowFiltering: false
        },
        {
            caption: 'Вид',
            name: 'vid_name',
            dataField: 'vid_name',
            visible: true,
            index: 2,
            width: 100,
            allowFiltering: false
        },
        {
            caption: 'Название',
            name: 'name',
            dataField: 'name',
            visible: true,
            index: 3,
            allowFiltering: false
        },
        {
            caption: 'Источник тепла',
            name: 'tec_name',
            dataField: 'tec_name',
            visible: true,
            index: 4,
            allowFiltering: false
        },

    ],
    viewId: "view-tep-tree-search"
}
</script>
<style scoped>
    .clearBtn {
        position: absolute;
        right: 0;
        z-index: 1;
        top: 0;
        width: 24px;
        height: 100%;
        cursor: pointer;
    }
</style>
